@if (!isGMSign) {
  <div class="accountLogin__bodySection"
       [ngClass]="{'sdex-env': envType == appType.dams || envType == appType.clms}">
    <div class="accountLogin__body" [ngClass]="{'sdex-env-dams_box': envType == appType.dams || envType == appType.clms}">
      <div class="accountLogin__section"
           [ngClass]="{'sdex-env-dams': envType == appType.dams || envType == appType.clms}">
        @if (isLogoLoaded) {
          <div>
            <div [ngClass]="envType !== 'SDEX' ? 'accountLogin__logo_url' : 'accountLogin__logo'">
              <!-- Case 1: SDEX Environment -->
              @if (customUrldata?.logo) {
                <div class="customLogo">
                  <img [src]="customUrldata?.logo" alt="SDEX" />
                </div>
              } @else {
                <img src="../../../assets/Images/login/headerLogo.svg" alt="">
                <img src="../../../assets/Images/login/sdexLogo.svg" alt="sdex">
              }
            </div>
          </div>
        }
        <form name="loginForm" [formGroup]="loginForm">
          <div class="accountLogin__signIn">
            <div class="accountLogin__welcome">Welcome to</div>
            @if (envType == appType.sdex) {
              <div class="accountLogin__welcomeHeader">Secured Document Exchange</div>
            }
            @if (envType == appType.dams && !customUrldata?.companyName) {
              <div class="accountLogin__welcomeHeader_dams">Intelligent Document Processing
              </div>
            }
            @if (envType == appType.clms) {
              <div class="accountLogin__welcomeHeader_dams">Contract Management System</div>
            }
            @if (customUrldata?.companyName){
              <div class="accountLogin__welcomeHeader_dams">{{customUrldata?.companyName}}</div>
            }
            @if (totpPendingId) {
              <div class="accountLogin__inputWrapper">
                <div class="accountLogin__inputSection">
                  <div class="userManagementUsersList__user-management-section">
                    <section class="organisationalDetails__container">
                      <div class="organisationalDetails__details">
                        <p class="userManagementUsersList__user-management-section1">Additional verification required</p>
                        <p>Username: {{ loginForm.get('username')?.value || '' }} <span
                          class="cursor-pointer link-underline link-primary" (click)="this.totpPendingId = undefined">(Not
                              you?)</span></p>
                        <br>
                        <p>Please enter the six digit code from your authenticator app.</p>
                        <span>MFA code </span>
                        <app-input-filed type="number" maxlength="6"
                                         [control]="$any(loginForm).controls['totp']"></app-input-filed>
                        <div class="mfa-sign">
                          <app-common-button buttonClass="smallFilledButton" [buttonLabel]="'Sign In'"
                                             custButtonClass="custButtonClass" [loadingIcon]="signInLoader" [typeBtn]="true"
                                             (clickEvent)="verifyTotp()">
                          </app-common-button>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            }
            @if (!totpPendingId) {
              <div class="accountLogin__inputWrapper">
                <div class="accountLogin__inputSection">
                  <div class="accountLogin__inputLabel">Email</div>
                  <app-input-filed (inputEvent)="inputEvent($event)" [control]="$any(loginForm).controls['username']"
                                   placeholder="Email"> </app-input-filed>
                  @if (loginForm.get('username')?.invalid && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched)) {
                    <div class="errorText"
                    >
                      @if (loginForm.get('username')?.errors?.['pattern']) {
                        <div>
                          <small class="text-danger">Please enter valid email</small>
                        </div>
                      }
                      @if (loginForm.get('username')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Email is required</small>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="accountLogin__inputSection">
                  <div class="accountLogin__inputLabel"> Password</div>
                  <div class="usersFilter__branchesField" [ngClass]="{'sdex-env-input': envType == 'DAMS'}">
                    <div class="usersFilter__branchWrappar">
                      <input (input)="inputEvent($event)" [type]="'password'" id="password"
                             class="usersFilter__input overrideInputfield" style="
              border: none !important;
              outline: none !important;
              box-shadow: none !important;
              border-color: #000 !important;
              width: 320px;
            " type="{{ hide ? 'password' : 'text' }}" formControlName="password" placeholder="Password" />
                      <fa-icon class="usersFilter__searchIcon" [icon]="hide ? faEye : faEyeSlash" (click)="hide = !hide"
                               [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hide"></fa-icon>
                    </div>
                  </div>
                  @if (loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)) {
                    <div class="errorText"
                    >
                      @if (loginForm.get('password')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Password is required</small>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            @if (!totpPendingId) {
              <div class="accountLogin__forgotPassword">
                <div class="accountLogin__remember">
                  <a style="text-decoration: none;" [routerLink]="['/setup-account']" class="text-link">
                    <div class="accountLogin__rememberText">Setup Password</div>
                  </a>
                </div>
                <a style="text-decoration: none;" [routerLink]="['/forgot-password']">
                  <div class="accountLogin__passwordText">Forgot Password ?</div>
                </a>
              </div>
            }
            @if (!totpPendingId) {
              <div class="accountLogin__button">
                <app-common-button (clickEvent)="onLogin()" buttonClass="smallFilledButton" [buttonLabel]="'Sign In'"
                                   custButtonClass="custButtonClass" disableButtonClass="largeButtonDisable" [loadingIcon]="signInLoader"
                                   [typeBtn]="true" [disabled]="loginForm.invalid || signInLoader">
                </app-common-button>
              </div>
            }
            @if (!hideSSO) {
              <div [ngClass]="{'mfa-sso': totpPendingId}" class="btn-sso">
                <app-common-button [loadingIcon]="isGoogleSign" (clickEvent)="googleSignIn('google')"
                                   [isImg]="'../../../assets/Images/login/google.png'" buttonClass="ssoButton"
                                   [buttonLabel]="'Sign In with Google'">
                </app-common-button>
                <app-common-button [loadingIcon]="isMicrosoftSign" (clickEvent)="googleSignIn('microsoft')"
                                   [isImg]="'../../../assets/Images/login/microsoft.png'" buttonClass="ssoButton"
                                   [buttonLabel]="'Sign In with Microsoft'">
                </app-common-button>
              </div>
            }
            <div class="mt-2 text-center text-danger pb-3 error-msg-wd">
              {{errorLogin}}
              @if (isChangePassword) {
                <span>
                            <div class="accountLogin__passwordText">Click
                              <span><a href="javascript:" style="color: rgb(222 113 65);" (click)="changePassword()">here</a></span>
                              to change password
                            </div>
                          </span>
              }
            </div>
          </div>
        </form>
      </div>
      @if (envType=='SDEX') {
        <app-logo></app-logo>
      }
    </div>
  </div>
}
